module.exports = __webpack_public_path__ + "img/11-2.36a5c48e.png";